import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { IHttpRequestConfig } from "@/browser";
import { Typeahead } from "@/components/Typeahead";
import { fetchRolesList, IFetchRolesListParams, IRole } from "@/data/roles";
import { ITypeaheadProps, typeaheadFactory } from "@/eworkitComponents";

const TypeaheadRole: FC<ITypeaheadProps> = memo(props => {
  const { t } = useTranslation("session");
  return <Typeahead placeholder={t("COMPONENTS.TYPEAHEAD_ROLE.PLACEHOLDER")} {...props} />;
});

const fetchProxy = async (query: IFetchRolesListParams, options: IHttpRequestConfig) => {
  const results = await fetchRolesList(
    { ...query, size: 1000, sortConfig: [{ sortBy: "customRole", order: "ASC" }] },
    options,
  );
  return results.content;
};

export const TypeaheadRoles = typeaheadFactory<ITypeaheadProps, IRole, IFetchRolesListParams>(
  fetchProxy,
  TypeaheadRole,
);
